import '@babel/polyfill'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import App from './App.vue'

import Vuex from 'vuex'
import router from './router'
import './theme/default.styl'
import themes from './theme/themes'
import axios from 'axios'
import VModal from 'vue-js-modal'


Vue.config.productionTip = false
/**
 * Use botfriends theme as default at first -> only visible at login
 * Define theme variations used throughout the project
 */
Vue.use(Vuetify, {
  theme: themes.telekomTheme,
  iconfont: 'md',
  options: {
    themeVariations: ['primary', 'secondary', 'accent', 'success', 'open', 'expired']
  }
})
/**
 * Initialize a state container that makes information accessible in all components
 * and define allowed modifications to it
 */
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    jwt: localStorage.getItem('token'),
    theme: localStorage.getItem('theme'),
  },
  mutations: {
    updateToken (state, newToken) {
      localStorage.setItem('token', newToken)
      state.jwt = newToken
    },
    removeToken (state) {
      localStorage.removeItem('token')
      state.jwt = null
    },
    setTheme (state, theme) {
      localStorage.setItem('theme', theme)
      state.theme = theme
    },
    removeTheme (state) {
      localStorage.removeItem('theme')
      state.theme = null
    },
    setRole(state, newRole) {
      localStorage.setItem('role', newRole)
      state.role = newRole
    },
    removeRole(state){
      localStorage.removeItem('role')
      state.role = null
    }
  }
})
/**
 * Define interceptor to set authentication header before request is sent.
 * Use jwt token from local browser storage.
 */
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

const timeoutInMS = 30 * 60 * 1000; // 30 minutes 
let timeoutId;
  
function handleInactive() {
    window.getApp.$emit('APP_LOGOUT');
}

function startTimer() { 
    // setTimeout returns an ID (can be used to start or clear a timer)
    timeoutId = setTimeout(handleInactive, timeoutInMS);
}

function resetTimer() { 
    clearTimeout(timeoutId);
    startTimer();
}
 
function setupTimers () {
    document.addEventListener("keypress", resetTimer, false);
    document.addEventListener("mousemove", resetTimer, false);
    document.addEventListener("mousedown", resetTimer, false);
    document.addEventListener("touchmove", resetTimer, false);
     
    startTimer();
}


new Vue({
  render: h => h(App),
  store,
  router,
  components: { App },
  template: '<App/>',
  beforeMount(){
    setupTimers()
  }
}).$mount('#app')


Vue.use(VModal)

